import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OptionItem } from '@ca/core/models';
import { workflowCategoriesToOptionItems } from '@ca/utils';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ListResult } from '../models/list-result';
import { WorkflowCategoryV1Read } from '../models/workflow-category-v1-read';
import { UserNotificationService } from './user-notification.service';
import { WorkflowCategoriesV1Service } from './workflow-categories-v1.service';

@Injectable({
    providedIn: 'root',
})
export class WorkflowCategoryOptionsService {
    categoryOptions$: Observable<OptionItem<string>[]>;

    constructor(
        private workflowCategoriesV1Service: WorkflowCategoriesV1Service,
        protected userNotificationService: UserNotificationService,
    ) {
        this.categoryOptions$ = this.workflowCategoriesV1Service.getCategories().pipe(
            map(({ data }: ListResult<WorkflowCategoryV1Read>) => workflowCategoriesToOptionItems(data)),
            catchError((err: HttpErrorResponse) => {
                const errorMessage = err.message ? err.message : JSON.stringify(err);
                this.userNotificationService.showError(errorMessage || 'Failed loading categories');
                return throwError(err);
            }),
        );
    }
}
